module.exports = __webpack_public_path__ + "img/pikachu.5bc6bc79.gif";